<template>
  <div v-if="isDesign || (sPID && sCurLinkID && !queryString.isHide)" class="ds-control ds-form-item ds-textbox" :class="getCss">
    <DsfFieldLabel
      v-if="showLabel"
      :mode="showDataCaptionMode"
      :style="getLabelWidthStyle()"
      :show-icon="showDataCaptionIcon"
      :trigger="showDataCaptionTrigger"
      :data-caption="dataCapion"
      :is-design="isDesign"
      :owner="_self">
      {{ $t(label) }}
    </DsfFieldLabel>
    <div class="ds-form-block" :style="getFormItemBlockMarginLeft()">
      <template v-if="!readOnly">
        <div class="dis-eara" style="margin-bottom: 10px">
          <el-input
            v-model="sOpinion.Content"
            :placeholder="placeholder"
            :type="isTextarea ? 'textarea' : 'text'"
            :rows="textareaRows"
            :disabled="disabled"
            :class="{
              'ds-error-border': errors.length>0,
              'is-disabled': disabled,
              'one-btns': visibleUpBtn || visibleOptionsBtn,
              'two-btns': visibleUpBtn && visibleOptionsBtn
            }"
          />
          <div class="dis-btns">
            <i v-if="visibleUpBtn" class="iconfont icon-cloud-upload" title="上传附件" @click="upload"></i>
            <el-popover v-model="showOptions" placement="right" width="360" trigger="click">
              <ul class="temp-list">
                <li v-for="(option, index) in options" :key="index" :title="option.key_word" class="item" @click="setValue(option)">
                  {{ option.key_word }}
                </li>
              </ul>
              <i v-if="visibleOptionsBtn" slot="reference" class="iconfont icon-detail temp-icon" title="一键模板"></i>
            </el-popover>
          </div>
        </div>
        <DsfUploadFile ref="uploadFile" v-model="uploadFiles" :show-label="false" :hide-btns="true" />
      </template>
      <!--只读状态只显示div-->
      <div v-else-if="readOnly" class="ds-form-readonly">
        <DsfTextProxy
          v-model="sOpinion.Content"
          v-bind="_self.$props"
          :show-label="false"
        ></DsfTextProxy>
      </div>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfDisposeIdea",
  mixins: [$mixins.formControl, $mixins.disposeIdea]
});
</script>
